<template>
  <div>
    <el-footer>

      <div class="footer" style="width: 100%;min-width: 1240px" >
        <div><h5 style="margin: 0;padding-top:160px">友情链接</h5>
          <a href="http://www.ysacamp.com/">工橙院</a> |
          <a href="https://www.icourse163.org/">百度课堂</a> |
          <a href="https://www.ibaidu.com/">MOOC慕课</a> |
          <a href="https://ke.qq.com/">腾讯课堂</a>
          <br>
            <img src="../../../assets/image/logo.png" alt="" style="height: 40px">
          <br>
          © 2021 北京青创赢教育科技有限公司<a> 备案号：京ICP备2020049216号-1</a>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: "FootBar"
}
</script>

<style lang="less" scoped>

.footer {
  height: 380px;
  background-image: url("../../../assets/image/footer.jpg");
}

p {
  margin: 0;
  margin-top: 10px;
  font-size: 13px;
}

a {
  font-size: 13px;
  color: #8A8A8A;
  text-decoration: none;
}

</style>
